// extracted by mini-css-extract-plugin
module.exports =  {"quick-questions-carousel":"F1ASVpx","quickQuestionsCarousel":"F1ASVpx","carousel-quick-question":"_3DXRmd5","carouselQuickQuestion":"_3DXRmd5"};